<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>搜索列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_all search_input_box">
      <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
      <el-button type="primary" @click="getlist()">搜索</el-button>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>搜索</span>
          <span class="comment_btn" :class="tabName === 'all' ? 'act' : ''" @click="sortBtn('all')">全部</span>
          <span class="comment_btn" :class="tabName === 'live' ? 'act' : ''" @click="sortBtn('live')">直播</span>
          <span class="comment_btn" :class="tabName === 'video' ? 'act' : ''" @click="sortBtn('video')">视频</span>
          <span class="comment_btn" :class="tabName === 'article' ? 'act' : ''" @click="sortBtn('article')">文章</span>
          <span class="comment_btn" :class="tabName === 'user' ? 'act' : ''" @click="sortBtn('user')">用户</span>
          <el-divider></el-divider>
        </p>
      </div>
      <none-view v-if="list.length === 0" :login="load.login" :loading="load.loading" :data="list" :text="load.text"></none-view>
      <div v-else class="conciseList_box">
        <div v-show="tabName !== 'user'">
          <div v-for="item in list" :key="item.id" class="conciseList_item" @click="jump(item.list_id, item.nav_id)">
            <div class="conciseList_item_left">
              <p v-if="item.img !== ''" class="conciseList_item_img">
                <img :src="item.img" alt="">
              </p>
              <div class="conciseList_item_content" :class="item.img_path === '' ? '' : 'conciseList_item_content_img'">
                <p class="conciseList_item_title">
                  {{item.title}}
                </p>
                <p class="conciseList_item_time">
                  {{item.add_time}}
                </p>
              </div>
            </div>
            <div class="conciseList_item_right">
              <!-- <el-button type="primary" icon="el-icon-search">搜索</el-button> -->
              <button class="my_follow_btn" @click="jump(item.list_id, item.nav_id)">查看</button>
            </div>
          </div>
        </div>
        <div v-show="tabName === 'user'">
          <div class="contacts_list_box">
            <div class="contacts_list">
              <div class="contacts_list_item lf" v-for="(item, index) in list" :key="item.id">
                <div class="contacts_list_item_top">
                  <img :src="item.portrait" alt="">
                  <dl class="contacts_info">
                    <dt>
                      <a @click="userJump(item.user_id)">{{item.user_name}}</a>
                    </dt>
                    <dd>{{item.content}}</dd>
                  </dl>
                </div>
                <div class="contacts_list_item_bottom">
                   <p class="contacts_other lf">
                     <span>{{item.fans_count}}</span> 人关注
                   </p>
                   <p class="contacts_btn rt">
                     <button v-show="item.is_follow === 0" class="my_follow_btn" @click = "addFollow(item.user_id, index, 'my')">+ 关注</button>
                     <button v-show="item.is_follow === 1" class="glay_btn" @click = "cancelFollow(item.user_id, index, 'my')">已关注</button>
                   </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="list.length > 0" class="page_box">
          <page-view :limit="listPage.limit" :list="list" :type="listPage.sort" @pageType="morePage"></page-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page from '../Public/page.vue'
import none from '../Public/none.vue'
export default {
  components: {
    pageView: page,
    noneView: none
  },
  data () {
    return {
      searchVal: '', // 搜索内容
      tabName: 'all', // 栏目切换
      load: {
        login: false, // 是否需要验证登陆
        loading: true, // 加载动画开关
        text: '暂无搜索内容' // 列表为空时的提示信息
      },
      list: [], // 搜索列表
      listPage: { // 搜索列表分页参数
        value: '',
        limit: 10,
        page: 1,
        type: 0
      }
    }
  },
  created () {
    this.searchVal = this.$route.query.val
    this.getlist()
  },
  methods: {
    // 获取列表
    getlist () {
      const vueThat = this
      vueThat.listPage.value = vueThat.searchVal
      vueThat.myApi.search(vueThat.listPage).then((res) => {
        if (res.data.code === 200) {
          vueThat.load.loading = false
          vueThat.list = res.data.data
        }
      })
    },
    // 列表排序
    sortBtn (name) {
      const vueThat = this
      vueThat.tabName = name
      vueThat.list = [] // 重置评论列表
      vueThat.loading = true // 开启加载动画
      vueThat.listPage.page = 1
      switch (name) {
        case 'all':
          vueThat.listPage.type = 0
          break
        case 'live':
          vueThat.listPage.type = 1
          break
        case 'video':
          vueThat.listPage.type = 2
          break
        case 'article':
          vueThat.listPage.type = 3
          break
        case 'user':
          vueThat.listPage.type = 4
          break
      }
      vueThat.getlist()
    },
    // 页面跳转
    jump: function (rid, navId) {
      console.log(rid)
      this.mycommon.detailJump(this, rid, navId)
    },
    // 加载更多
    morePage (num, type) {
      const vueThat = this
      vueThat.listPage.page = num
      vueThat.listPage.sort = type
      vueThat.getlist()
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 添加关注
    addFollow (id, index, type) {
      const vueThat = this
      vueThat.myApi.addFollow({ user_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.$message({
            message: '关注成功！',
            type: 'success'
          })
          vueThat.list[index].is_follow = 1
          vueThat.list[index].fans_count += 1
        }
      })
    },
    // 取消关注
    cancelFollow (id, index, type) {
      const vueThat = this
      vueThat.$confirm('确认取消关注？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vueThat.myApi.cancelFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '取消关注成功！',
              type: 'success'
            })
            vueThat.list[index].is_follow = 0
            vueThat.list[index].fans_count -= 1
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
  .search_input_box{
    box-sizing: border-box;
    position: relative;
    width: 800px;
    margin: 0 auto;
    margin-bottom: 20px;
    padding-right: 100px;
  }
  .search_input_box .el-button{
    position: absolute;
    padding: 12px 30px;
    top: 0;
    right: 0;
  }
</style>
